import React from "react";

const FooterTwitterIcon = (): JSX.Element => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 319.81 290.74"
  >
    <defs>
      <clipPath id="clip-path-6a" transform="translate(-146.1 -153.38)">
        <path
          className="cls-1" fill="none" clip-rule="evenodd"
          d="M252.07,415v0a170.92,170.92,0,0,1-91.44-26.34,122.43,122.43,0,0,0,14.2.84,120.82,120.82,0,0,0,74.08-25.19,59.6,59.6,0,0,1-55.73-40.78,60.38,60.38,0,0,0,26.94-1C192.28,317,172.28,292.9,172.26,265v-.74a59.87,59.87,0,0,0,27.07,7.35,58.22,58.22,0,0,1-18.46-78.39A170.27,170.27,0,0,0,303.8,254.53a58.5,58.5,0,0,1,30-65.13A60.42,60.42,0,0,1,405.46,201a120.47,120.47,0,0,0,37.87-14.25,59.06,59.06,0,0,1-26.23,32.48A120.58,120.58,0,0,0,451.37,210a120.37,120.37,0,0,1-29.76,30.39c.18,2.52.18,5.05.18,7.59C421.79,325.55,361.78,415,252.07,415Z"
        />
      </clipPath>
      <clipPath id="clip-path-6b" transform="translate(-146.1 -153.38)">
        <rect className="cls-2" fill="none" x="160.63" y="153.38" width="290.74" height="290.74" />
      </clipPath>
      <clipPath id="clip-path-3" transform="translate(-146.1 -153.38)">
        <rect className="cls-2" x="160.63" y="167.91" width="290.74" height="261.66" />
      </clipPath>
    </defs>
    <g className="cls-3" clip-path="url(#clip-path-6a)">
      <g className="cls-4">
        <g className="cls-5" clip-path="url(#clip-path-6a)">
          <g className="cls-6" clip-path="url(#clip-path-6b)">
            <rect width="319.81" height="290.74" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default FooterTwitterIcon;
